(function () {
  try {
    var HEADER_OFFSET = 100;
    var MAX_WAIT_MS = 8000;
    var POLL_INTERVAL_MS = 150;
    var TRIGGER_SELECTOR = '[data-scroll-to-reviews]';

    function findWidget() {
      try {
        // okendo-lazy-widget.liquid renames the attribute until hydration.
        return document.querySelector('[data-oke-widget], [data-oke-widget-deferred]');
      } catch (e) {
        return null;
      }
    }

    function scrollToWidget(el) {
      try {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      } catch (e) {}
    }

    // Move focus like a native in-page link would, without a second scroll.
    function focusWidget(el) {
      try {
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      } catch (e) {}
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;
      var el = findWidget();
      // No widget on this page: fall back to the link's own href.
      if (!el) return;
      event.preventDefault();
      scrollToWidget(el);
      focusWidget(el);
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('anchor') !== 'reviews') return;

    var startedAt = Date.now();

    function poll() {
      var el = findWidget();
      if (el) {
        scrollToWidget(el);
        return;
      }
      if (Date.now() - startedAt > MAX_WAIT_MS) return;
      setTimeout(poll, POLL_INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', poll);
    } else {
      poll();
    }
  } catch (e) {}
})();
